export default {
    _prefix: "ReadOnlyInput",
    screenreader: {
        radio: {
            active: "Active option",
            inactive: "Inactive option",
        },
        checkbox: {
            selected: "Selected",
            unselected: "Unselected",
        },
    },
};
